import { Component, inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { EmailVerifyService } from '../../services/email-verify.service';

@Component({
  selector: 'app-email-verify-banner',
  imports: [],
  templateUrl: './email-verify-banner.html'
})
export class EmailVerifyBanner {
  authService = inject(AuthService);
  emailVerifyService = inject(EmailVerifyService);
}
